export default "__VITE_ASSET__BVP$l93c__"